
export const toNumber = (value: string | number | undefined, defaultValue: number = 0) => {
  return !value ? defaultValue : Number(value);
};
